import { Avatar, ColorScheme, Drawer, Image, Space, Stack } from '@mantine/core';
import 'keen-slider/keen-slider.min.css';
import '../ratpack-ui/src/app/AppImports';
import { Anchor } from '../ratpack-ui/src/components/Anchor/Anchor';
import { Text } from '../ratpack-ui/src/components/Text/Text';
import { AdminPageLayout } from '../ratpack-ui/src/pages/AdminPageLayout';
import '../ratpack-ui/src/styles/Font.css';
import * as React from 'react';
import { Link } from "react-router-dom";

import iconBus from '../assets/bus.png'
// import logo from '../assets/logo.svg'
// import logo from '../assets/images/logo2.png'
import { useRecoilValue } from 'recoil';
import { userAtom } from '../session';
import { niceDate } from '../time';
import availability from './availability';
import { useDisclosure } from '@mantine/hooks';

export const home = '/search'
export const login = '/login'

export const hotPink = '#ff195e'

export const activeColorBind = hash => (url, yes = "Yellow", no = "White") => hash.startsWith(url) ? 'Yellow' : 'White'
export type Page = 'list' | 'create' | 'settings' | 'availability' | 'payments' | 'team' | 'operators' | 'availability-tool'
export const header = ({
    page = 'list' as Page,
}) => {
    const user = useRecoilValue(userAtom)
    const [opened, { open, close }] = useDisclosure(false);
    const links = [

        ['heading', '', 'Sales'],
        ['payments', '/admin/payments', 'Payment Sheet'],
        user.admin && ['team', '/admin/team', 'Team Management'],
        ['payments', '/admin/payments?dashboard', 'Dashboards'],

        ['heading', '', 'Quotes'],
        ['create', '/admin/create-quote', 'Search'],
        ['availability-tool', '/admin/tool/availability', 'Availability Tool'],
        user.admin && ['quotes', '/admin/quotes', 'Search Results'],

        user.admin && ['heading', '', 'Admin'],
        user.admin && ['availability', '/admin/availability', 'Availability'],
        user.admin && ['operators', '/admin/operators', 'Operators'],
        user.admin && ['direct', '/api/data/csv/this/year', 'Payment List (CSV)'],

        user.admin && ['heading', '', 'System'],
        user.admin && ['direct', '/api/system/list_all_products.csv', 'Product List (JSON)'],
        user.admin && ['direct', '/api/system/operators.json', 'Operator List (JSON)'],


        user.admin && ['heading', '', 'Legacy'],
        user.admin && ['settings', '/admin/settings', 'Manual Pricing'],

    ].filter(Boolean) as Array<[Page|'hr'|'heading'|'direct', string, string?]>
    const capitalize = (s:string) => s[0].toUpperCase()+s.slice(1)
    return (<AdminPageLayout.Header
        leftContent={(
            <div style={{ display: 'flex', alignItems: 'center', width:'100%'}}>
                <Image
                    src={iconBus.default}
                    height={'3.5rem'}
                    width={'auto'}
                    onClick={open}
                    style={{
                        borderRadius: '50%',
                        transition: `all .3s ease`,
                        // boxShadow: `0 0 15px ${hotPink}88`,
                    }}
                    onMouseEnter={e=>Object.assign(e.currentTarget?.style??{},{
                        boxShadow: `0 0 15px ${hotPink}`,
                    })}
                    onMouseLeave={e=>Object.assign(e.currentTarget?.style??{},{
                        boxShadow: `0 0 0px ${hotPink}00`,
                    })}
                />
                <Drawer
                    opened={opened}
                    onClose={close}
                    title=""
                    withCloseButton={false}
                    overlayProps={{ opacity: 0.5, blur: 4 }}
                >
                    <Stack>
                        {links.map(([p,url,title])=>{
                            if(p=='hr') return (<hr/>)
                            if(p=='heading') return (<>
                                <Text
                                    bold
                                    style={{ color:'gray', fontWeight: 400, fontSize: '20px' }}
                                >
                                    {title??capitalize(p)}
                                </Text>
                                <Space w={24} />
                            </>)
                            if(p=='direct') return (<>
                                <Anchor
                                    href={url}
                                    styleType="black"
                                    style={{ fontWeight: 400, paddingLeft: '25px' }}
                                >
                                    {title??capitalize(p)}
                                </Anchor>
                                <Space w={24} />
                            </>)
                            return (<>
                                <Link to={url}><Anchor
                                    styleType="black"
                                    style={{ fontWeight: page == p ? 600 : 400, paddingLeft: '25px' }}
                                >
                                    {title??capitalize(p)}
                                </Anchor></Link>
                                <Space w={24} />
                            </>)
                        })}
{/*                         
                        <Link to="/admin/create-quote"><Anchor
                            styleType="black"
                            style={{ fontWeight: page == 'create' ? 600 : 400 }}
                        >
                            Search
                        </Anchor></Link>
                        <Space w={24} />
                        <Link to="/admin/settings"><Anchor
                            styleType="black"
                            style={{ fontWeight: page == 'settings' ? 600 : 400 }}
                        >
                            Settings
                        </Anchor></Link>
                        <Space w={24} />
                        <Link to="/admin/availability"><Anchor
                            styleType="black"
                            style={{ fontWeight: page == 'availability' ? 600 : 400 }}
                        >
                            Availability
                        </Anchor></Link>
                        <Space w={24} />
                        <Link to="/admin/payments"><Anchor
                            styleType="black"
                            style={{ fontWeight: page == 'payments' ? 600 : 400 }}
                        >
                            Payments
                        </Anchor></Link>
                        {user?.admin && <><Space w={24} />
                        <Link to="/admin/team"><Anchor
                            styleType="black"
                            style={{ fontWeight: page == 'team' ? 600 : 400 }}
                        >
                            Team
                        </Anchor></Link> */}
                    {/* </>} */}

                    </Stack>
                </Drawer>
            </div>
        )}
        rightContent={(
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <Avatar src={user?.avatar ?? ''} size={56} radius={999} />
                <Space w={20} />
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Text>{user?.name}</Text>
                    <Anchor component={Link} styleType="gray" to="/logout">
                        Log out
                    </Anchor>
                    <Text size='xs'>{niceDate()}</Text>
                </div>
                {/* <DarkModeButton/> */}
            </div>
        )}
    />)
}
export const adminDefaults = ({
    page = 'list' as Page,
}) => ({ header: header({ page }) })

export function DarkModeButton() {
    const [colorScheme, setColorScheme] = React.useState<ColorScheme>('light');
  
    React.useEffect(() => {
      const stored = localStorage.getItem('theme');
      if (stored === 'dark' || stored === 'light') {
        setColorScheme(stored);
      }
    }, []);
  
    const toggleColorScheme = (value?: ColorScheme) => {
      const newScheme = value || (colorScheme === 'dark' ? 'light' : 'dark');
      setColorScheme(newScheme);
      localStorage.setItem('theme', newScheme);
    };
  
    return (<button onClick={() => toggleColorScheme()}>
        {colorScheme === 'light' ? '🌞' : '🌙'}
    </button>)
}
